module.exports = __webpack_public_path__ + "46568d8df9dc242547938dcbde1df0a4.svg";